"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDevicePreview = void 0;
const _1 = require(".");
const ValueObjects_1 = require("../ValueObjects");
function makeDevicePreview() {
    return new DevicePreviewImp();
}
exports.makeDevicePreview = makeDevicePreview;
class DevicePreviewImp {
    constructor() {
        this.observers = new _1.ObserverList();
        this._usePreview = false;
        this._previewSize = ValueObjects_1.Vector2.Zero();
        this.setDevicePreview = (x, y) => {
            if (this._previewSize.x === x &&
                this._previewSize.y === y)
                return;
            this._usePreview = true;
            this._previewSize = new ValueObjects_1.Vector2(x, y);
            if (x > 0 && y > 0) {
                this._usePreview = true;
            }
            else {
                this._usePreview = false;
            }
            this.observers.notify();
        };
        this.clearDevicePreview = () => {
            if (!this._usePreview)
                return;
            this._previewSize = ValueObjects_1.Vector2.Zero();
            this._usePreview = false;
            this.observers.notify();
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
    }
    get useDevicePreview() {
        return this._usePreview;
    }
    get previewSize() {
        return this._previewSize;
    }
}
